import { SwitchUsersForm } from 'authOld/components';
import { IAuthUser } from 'authOld/types';
import { DropdownNav } from 'coreOld/components';
import { HeaderModalOptions } from 'coreOld/constants';
import { Icon } from 'coreOld/elements';
import { DropdownOptions } from 'coreOld/types';

import { navProfileStructure } from './navStructure';
import { iconStyle, navItemStyle, NavWrapper } from './profileNavStyle';

interface IProps {
  user: IAuthUser;
  collapsedMenu?: boolean;
  openedDropdown: DropdownOptions;
  toggleDropdown: (name: string) => void;
  openedAuthModal: HeaderModalOptions;
  openAuthModal: (type: HeaderModalOptions) => void;
  closeAuthModal: () => void;
  onUserVersionChange?: (user: IAuthUser) => void;
}

const ProfileNavView = ({
  user,
  collapsedMenu = false,
  openedDropdown,
  toggleDropdown,
  openedAuthModal,
  openAuthModal,
  closeAuthModal,
  onUserVersionChange,
}: IProps) => {
  return (
    <>
      <NavWrapper>
        <DropdownNav
          navItems={navProfileStructure(openAuthModal, user, collapsedMenu, onUserVersionChange)}
          icon={<Icon name={Icon.USER_PROFILE} style={iconStyle} />}
          name={user?.firstName}
          isOpen={openedDropdown.profile}
          toggleDropdown={() => toggleDropdown('profile')}
          style={navItemStyle}
          userResources={user?.resources}
        />
      </NavWrapper>

      <SwitchUsersForm
        isOpen={openedAuthModal === HeaderModalOptions.SWITCH_USERS}
        onClose={closeAuthModal}
      />
    </>
  );
};

export default ProfileNavView;
